import { render, staticRenderFns } from "./DlgGetOTP.vue?vue&type=template&id=594b5a88"
import script from "./DlgGetOTP.vue?vue&type=script&lang=js"
export * from "./DlgGetOTP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports